export var RaffleV2Type;
(function (RaffleV2Type) {
    RaffleV2Type["eth"] = "eth";
    RaffleV2Type["product"] = "product";
    RaffleV2Type["aleo"] = "aleo";
})(RaffleV2Type || (RaffleV2Type = {}));
export var GiveawayOperatorStatus;
(function (GiveawayOperatorStatus) {
    GiveawayOperatorStatus["idle"] = "idle";
    GiveawayOperatorStatus["minting"] = "minting";
    GiveawayOperatorStatus["mintFailed"] = "mintFailed";
    GiveawayOperatorStatus["minted"] = "minted";
    GiveawayOperatorStatus["drawing"] = "drawing";
    GiveawayOperatorStatus["drawFailed"] = "drawFailed";
    GiveawayOperatorStatus["drawn"] = "drawn";
    GiveawayOperatorStatus["sendingPrizes"] = "sendingPrizes";
    GiveawayOperatorStatus["sendingFailed"] = "sendingFailed";
    GiveawayOperatorStatus["sentPrizes"] = "sentPrizes";
})(GiveawayOperatorStatus || (GiveawayOperatorStatus = {}));
export var GiveawayOnChainStatus;
(function (GiveawayOnChainStatus) {
    GiveawayOnChainStatus["idle"] = "idle";
    GiveawayOnChainStatus["opening"] = "opening";
    GiveawayOnChainStatus["open"] = "open";
    GiveawayOnChainStatus["closing"] = "closing";
    GiveawayOnChainStatus["closed"] = "closed";
})(GiveawayOnChainStatus || (GiveawayOnChainStatus = {}));
export var GiveawayOpenStatus;
(function (GiveawayOpenStatus) {
    GiveawayOpenStatus["upcoming"] = "upcoming";
    GiveawayOpenStatus["ongoing"] = "ongoing";
    GiveawayOpenStatus["closed"] = "closed";
    GiveawayOpenStatus["full"] = "full";
    GiveawayOpenStatus["drawn"] = "drawn";
    GiveawayOpenStatus["ended"] = "ended";
})(GiveawayOpenStatus || (GiveawayOpenStatus = {}));
